import { render } from "./stocktransfer.vue?vue&type=template&id=0d5171b8&scoped=true"
import script from "./stocktransfer.vue?vue&type=script&lang=js"
export * from "./stocktransfer.vue?vue&type=script&lang=js"

import "./stocktransfer.vue?vue&type=style&index=0&id=0d5171b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d5171b8"]])

export default __exports__